<template>
  <!-- 底部宣传栏 -->
  <div v-if="showContact === 1 && isShow && false" class="contacts">
    <el-row class="main" style="max-width: 1200px; margin: 0 auto">
      <el-col :span="9">
        <el-row type="flex" align="middle">
          <el-col :span="8">
            <img src="/images/jzq-gzh.png" />
          </el-col>
          <el-col style="margin-left: 30px" :span="16">
            <p class="text">
              <i
                class="icon icon-wx-w"
                style="width: 18px; height: 16px; margin-right: 10px"
              ></i>
              <span class="tl">关注微信公众号</span>
            </p>
            <p class="text">锁定君子签最新资讯，还可在公众号上快速签署文件</p>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="9">
        <el-row type="flex" align="middle">
          <el-col :span="8">
            <img src="/images/jzq-xcx.png" />
          </el-col>
          <el-col style="margin-left: 30px" :span="16">
            <p class="text">
              <i
                class="icon icon-xcx-w"
                style="width: 18px; height: 18px; margin-right: 10px"
              ></i>
              <span class="tl">收藏微信小程序</span>
            </p>
            <p class="text">使用微信扫一扫添加小程序，文件签署更方便</p>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-row type="flex" align="top">
          <el-col
            :span="8"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <div style="margin-bottom: 10px">
              <img
                src="../../static/images/web/jzqlogo.png"
                alt="君子签"
                style="width: 60px; height: 20px"
              />&nbsp;&nbsp;&nbsp;&nbsp;|
            </div>
            <div style="margin-bottom: 10px">
              <img
                src="../../static/images/web/ebqlogo.png"
                alt="易保全"
                style="width: 60px; height: 20px"
              />&nbsp;&nbsp;&nbsp;&nbsp;|
            </div>
            <div style="margin-bottom: 10px">
              <img
                src="../../static/images/web/wbqlogo.png"
                alt="微版权"
                style="width: 60px; height: 20px"
              />&nbsp;&nbsp;&nbsp;&nbsp;|
            </div>
            <div
              style="
                width: 80px;
                height: 20px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
              "
            >
              <img
                src="../../static/images/web/phone.png"
                style="width: 12px; height: 12px; margin-right: 5px"
              />电话&nbsp;&nbsp;&nbsp;&nbsp;|
            </div>
          </el-col>
          <el-col
            :span="16"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
            "
          >
            <div
              style="
                margin-bottom: 10px;
                height: 20px;
                display: flex;
                align-items: center;
              "
            >
              <a href="https://www.junziqian.com" target="_blank">君子签官网</a>
              <!--              <a v-if="+$store.getters.currentAuthUser.merchantFlag===1" style="margin-left: 15px;cursor: pointer" :href="globalConfig.domain.junziqianApi + '/api_doc/index.html'" target="_blank">开发文档</a>-->
            </div>
            <div style="margin-bottom: 10px; height: 20px; line-height: 20px">
              <a :href="globalConfig.domain.forensicsWebOp" target="_blank"
                >电子数据保全中心</a
              >
            </div>
            <div style="margin-bottom: 10px; height: 20px; line-height: 20px">
              <a :href="globalConfig.domain.athenaWebUms" target="_blank"
                >知识产权保护平台</a
              >
            </div>
            <div style="height: 20px; line-height: 20px; font-weight: bold">
              400-808-9187
            </div>
            <!-- <a href="https://www.junziqian.com/help.html" target="_blank">帮助中心</a>-->
            <!-- <a v-if="$store.getters.currentAuthUser && $store.getters.currentAuthUser.userType === 1"-->
            <!-- href="javascript:void(0)" @click="$emit('showCorpAds')">集团账号</a>-->
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";


export default {
  name: "index",
  async beforeMount () {
    // 集团账户直接跳过接口，默认显示通底
    // if(this.$route.path === '/corp/viewIndex'){
    //   this.showContact = 1
    //   return
    // }
    let isSassRes = await ApiMethods.UserController.isJZQSass();
    if (isSassRes.success && isSassRes.data === 1) {
      // Sass用户，显示底部链接
      this.showContact = 1
    }
  },
  data () {
    return {
      showContact: 0,
      showRoute: [ // 显示底部宣传栏的路由,有的路由比如发起合同页不需要展示
        '/viewIndex',
        '/judicialService',
        '/blockChain',
        '/signInfo',
        '/tpl/personSet',
        '/tpl/general',
        '/tpl/corpSet',
        '/tpl/entSign',
        '/tpl/signMerge',
        '/tpl/signStatistics',
        '/tpl/score',
        '/tpl/costStatistics',
        '/tpl/digital',
        '/signSettings'
      ]
    }
  },
  computed: {
    isShow () {
      let arr = this.showRoute
      for (let i = 0; i < arr.length; i++) {
        if (this.$route.path.indexOf(arr[i]) > -1) {
          return true
        }
      }
      return false
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.contacts {
  padding: 20px 0;
  /*background-color: #333333;*/
  color: rgba(255, 255, 255, 0.65);
  /*border-bottom: solid 1px #808080;*/
  background: url("/images/web/footer.png") center center;
  background-size: 100% 100%;
  a {
    color: rgba(255, 255, 255, 0.65);
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
  .tl {
    color: rgba(255, 255, 255, 1);
  }
  .tel {
    display: block;
    line-height: 3;
  }
  .main {
    & > .el-col {
      padding-right: 110px;
      &:last-child {
        padding-right: 0;
      }
    }
    .text {
      line-height: 2.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/contacts/index.vue